import type { MatrixViewStateShape } from '@mss_creator/shared';

/** Index into 4 discrete text-size steps (design doc E13). */
export type ZoomStep = MatrixViewStateShape['zoomStep'];

export const ZOOM_STEP_MIN: ZoomStep = 0;
export const ZOOM_STEP_MAX: ZoomStep = 3;

/** Tailwind text-size class per zoom step — cascades to header and body text uniformly (E13). */
export const ZOOM_TEXT_CLASSES: Record<ZoomStep, string> = {
  0: 'text-caption',
  1: 'text-small',
  2: 'text-body',
  3: 'text-body-lg',
};

/** Clamps a candidate zoom step to the valid `[0, 3]` range. */
export function clampZoomStep(step: number): ZoomStep {
  if (step <= ZOOM_STEP_MIN) return ZOOM_STEP_MIN;
  if (step >= ZOOM_STEP_MAX) return ZOOM_STEP_MAX;
  return step as ZoomStep;
}
